import { useMemo, useState } from 'react';
import { AssociatedResourceProps } from 'componentsV2/product/details/content/subpages';
import { useAssociatedResource } from 'componentsV2/product/details/content/subpages/associated-resource/useAssociatedResource';
import {
  SInfiniteScroll,
  SNavigateButton,
  SText
} from '@setvi/shared/components';
import { ProductsEmptyState } from 'componentsV2/product/details/content/components';
import { Resource } from 'Interfaces';
import { Box, makeStyles } from '@material-ui/core';
import { buildResourceViewUrl } from '@setvi/shared/utils/viewer';
import { MobileResourceCard, MobileResourceLoader } from './components';
import { TabContentWrapper } from '../styled';

const useStyles = makeStyles(({ spacing }) => ({
  wrapper: {
    marginTop: spacing(2)
  }
}));

const keyGetter = (resource: Resource) => resource?.ID || 'test';

export const MobileAssociatedResources = ({
  product
}: AssociatedResourceProps) => {
  const [selectedResource, setSelectedResource] = useState(null);
  const { resources, isLoading } = useAssociatedResource({ product });
  const classes = useStyles();

  const content = useMemo(() => {
    if (selectedResource)
      return (
        <Box
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            backgroundColor: '#fff',
            height: '100vh',
            width: '100vw',
            zIndex: 1300
          }}>
          <Box
            display="flex"
            alignItems="center"
            gridGap="12px"
            p={2}
            height={55}>
            <SNavigateButton onClick={() => setSelectedResource(null)} />
            <SText weight="semibold" title={selectedResource.Name} />
          </Box>
          <iframe
            src={buildResourceViewUrl({
              name: selectedResource.Name,
              resourceTypeId: selectedResource.ResourceTypeID,
              resourceId: selectedResource.ResourceID
            })}
            style={{ width: '100%', height: 'calc(100% - 55px)' }}
            title="Resource Preview"
          />
        </Box>
      );

    if (isLoading) return <MobileResourceLoader />;

    if (!resources.length && !isLoading)
      return <ProductsEmptyState title="No Resources Available" />;

    return (
      <Box display="flex" flexDirection="column" gridGap={8}>
        <SInfiniteScroll
          list={resources}
          keyGetter={keyGetter}
          wrapperClass={classes.wrapper}
          onWrapperClick={setSelectedResource}
          render={resource => <MobileResourceCard resource={resource} />}
        />
        {isLoading && <MobileResourceLoader />}
      </Box>
    );
  }, [classes.wrapper, isLoading, resources, selectedResource]);

  return <TabContentWrapper>{content}</TabContentWrapper>;
};
